module.exports = __webpack_public_path__ + "img/empty-user-icon.f6585d20.png";